var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInsurance105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M52.5 63a.5.5 0 0 1 .5.5v20C53 89.852 58.148 95 64.5 95S76 89.852 76 83.5a.5.5 0 0 1 1 0C77 90.404 71.404 96 64.5 96S52 90.404 52 83.5v-20a.5.5 0 0 1 .5-.5Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M52.5 7a.5.5 0 0 1 .5.5v7.503c20.773.251 37.98 16.14 39.998 36.448A.5.5 0 0 1 92.5 52H12.5a.5.5 0 0 1-.498-.55C14.02 31.144 31.227 15.255 52 15.004V7.5a.5.5 0 0 1 .5-.5Zm.5 44h19v-3.5c0-13.636-7.708-25.246-19-31.183V51Zm-1-34.683V51H33v-3.5c0-13.636 7.708-25.246 19-31.183ZM13.056 51c2.16-19.01 17.992-33.932 37.343-34.945C39.419 22.32 32 33.933 32 47.5V51H13.056ZM73 47.5V51h18.944C89.784 31.99 73.952 17.068 54.6 16.055c10.98 6.266 18.4 17.878 18.4 31.445Z",
  clipRule: "evenodd"
})));
export { SvgInsurance105 as ReactComponent };
export default __webpack_public_path__ + "307a7f5a4f979314544ea88462ce263c.svg";